import { createSelector } from "reselect";

import { getMarketWaterfallUpsells } from "ducks/market/selectors";
import {
  getCategories,
  getDeliveryFeeProduct,
  getProducts,
} from "ducks/menu/selectors";
import {
  getCanApplyDeliveryFeeProduct,
  getCurrentOrderProducts,
} from "ducks/order/selectors";

export const getWaterfallUpsell = ({
  waterfallUpsell = { seen: false },
} = {}) => waterfallUpsell;

export const getIsWaterfallUpsellSeen = createSelector(
  [getWaterfallUpsell],
  ({ seen }) => seen
);

export const getOrderWaterfallUpsells = createSelector(
  [
    getIsWaterfallUpsellSeen,
    getMarketWaterfallUpsells,
    getProducts,
    getCurrentOrderProducts,
    getCategories,
    getCanApplyDeliveryFeeProduct,
    getDeliveryFeeProduct,
  ],
  (
    isWaterfallUpsellSeen,
    marketUpsells,
    menuProducts,
    orderProducts,
    categories,
    canApplyDeliveryFeeProduct,
    deliveryFeeProduct
  ) => {
    const skipWaterfallUpsell = isWaterfallUpsellSeen || !marketUpsells.length;
    const mapMenuProductToUpsell = (product) => {
      const { productDescription, productId, productName } = product;
      const { categoryId = "" } =
        Object.values(categories).find(({ productIds = [] }) =>
          productIds.includes(productId)
        ) || {};

      return {
        baseId: "",
        productDescription,
        productId,
        productName,
        sizeId: "",
        categoryId,
      };
    };
    if (skipWaterfallUpsell && !canApplyDeliveryFeeProduct) return [];
    else if (skipWaterfallUpsell && canApplyDeliveryFeeProduct) {
      return [mapMenuProductToUpsell(deliveryFeeProduct)];
    }

    const orderProductCategories = [
      ...new Set(
        Object.values(orderProducts)
          .map(({ parts = {} } = {}) =>
            Object.values(parts)
              .map(({ productCode }) => {
                const [orderProductCategory] = Object.entries(categories).find(
                  ([, { productIds = [] }]) => productIds.includes(productCode)
                ) || [""];

                return orderProductCategory;
              })
              .filter(Boolean)
          )
          .flat()
      ),
    ];

    const upsellProducts =
      marketUpsells.find((upsells) => {
        const upsellsCategories = new Set(
          upsells.map(({ categoryId }) => categoryId)
        );

        return orderProductCategories.every(
          (category) => !upsellsCategories.has(category)
        );
      }) || [];

    const upsellMenuProducts = upsellProducts
      .filter(({ productId, sizeId }) => {
        const isValidProduct = Boolean(menuProducts[productId]);
        const isValidSize =
          !sizeId ||
          (isValidProduct && menuProducts[productId].sizeIds.includes(sizeId));
        return isValidProduct && isValidSize;
      })
      .map((upsellProduct) => {
        const { productDescription, productName } =
          menuProducts[upsellProduct.productId];
        return {
          ...upsellProduct,
          productDescription,
          productName,
        };
      });

    return [
      ...(canApplyDeliveryFeeProduct && deliveryFeeProduct
        ? [mapMenuProductToUpsell(deliveryFeeProduct)]
        : []),
      ...upsellMenuProducts,
    ];
  }
);
